// import { addCacheViews, deleteCacheViews } from "@/utils/cacheView";
/* import { viewMap } from "@/utils/settings";*/
import { getLang } from "./auth";

// 优化组织筛选的方法，解决筛选到的非叶子节点不显示子节点的问题
export function commonFilterNode(value, data, node) {
  // 将某一层级的所有节点名称放入到数组中，如果包含当前节点名，则保留显示
  if (!value) { return true; }
  let parentNode = node.parent;
  let labels = [node.label];
  let level = 1;

  while (level < node.level) {
    labels = [...labels, parentNode.label];
    parentNode = parentNode.parent;
    level++;
  }
  return labels.some(label => label.includes(value));
}

// 返回day的缩写，1号则返回1st
export function transferCheckTimeInput(value, type, vueCom) {
  const lang = getLang();
  const mapping = {
    month: "checkTime.dayOfTheMonth",
    nextMonth: "checkTime.dayOfTheFollowingMonth",
    year: "checkTime.monthOfTheYear",
    nextYear: "checkTime.monthOfTheFollowingYear"
  };
  const monthMapping = [
    {
      value: 1,
      en: "Jan"
    },
    {
      value: 2,
      en: "Feb"
    },
    {
      value: 3,
      en: "Mar"
    },
    {
      value: 4,
      en: "Apr"
    },
    {
      value: 5,
      en: "May"
    },
    {
      value: 6,
      en: "Jun"
    },
    {
      value: 7,
      en: "Jul"
    },
    {
      value: 8,
      en: "Aug"
    },
    {
      value: 9,
      en: "Sept"
    },
    {
      value: 10,
      en: "Oct"
    },
    {
      value: 11,
      en: "Nov"
    },
    {
      value: 12,
      en: "Dec"
    }
  ];
  const source = Number(value);
  // 月核算时间要换算天
  if (type === "month" || type === "nextMonth") {
    let day;
    if (isNaN(source)) { return null; }
    if (source === 1) {
      day = "1st";
    } else if (source === 2) {
      day = "2nd";
    } else if (source === 3) {
      day = "3rd";
    } else {
      day = `${source}th`;
    }
    if (lang === "zh") {
      return `${vueCom.$t(`${mapping[type]}`) + value}日`;
    }
    if (lang === "en") {
      return day + vueCom.$t(`${mapping[type]}`);
    }
  }
  // 年核算时间要换算月份
  if (type === "year" || type === "nextYear") {
    const month = monthMapping.find(item => item.value === source) || null;
    if (month) {
      if (lang === "zh") {
        return `${vueCom.$t(`${mapping[type]}`) + value}月`;
      }
      if (lang === "en") {
        return month.en + vueCom.$t(`${mapping[type]}`);
      }
    }
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, context, timestamp, result, argsValue;

  const later = function() {
    // 据上一次触发时间间隔
    const last = Number(new Date()) - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, argsValue);
        if (!timeout) { context = argsValue = null; }
      }
    }
  };

  return function(...args) {
    context = this;
    argsValue = args;
    timestamp = Number(new Date());
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) { timeout = setTimeout(later, wait); }
    if (callNow) {
      result = func.apply(context, args);
      context = argsValue = null;
    }

    return result;
  };
}

import { cloneDeep } from "./modules/clone-deep.js";
import { downloadFile } from "./modules/download-file.js";
import { getQuerystringObj } from "./modules/get-querystring-obj.js";
import { randomCode } from "./modules/get-random-string.js";
import { getTextWidth } from "./modules/get-text-width.js";
import * as validate from "./modules/operation_validate.js";
import { parseNumberToCNY } from "./modules/parse-number-to-CNY.js";
import * as localstorage from "./modules/storage.js";

export default {
  cloneDeep,
  downloadFile,
  getQuerystringObj,
  randomCode,
  getTextWidth,
  validate,
  parseNumberToCNY,
  localstorage
};
export * from "./utils";
export * from "./valid";
